import "./App.css";

function App() {
  return (
    <div className="App">
      <h1>Future site of SkyOneTaxi.com</h1>
    </div>
  );
}

export default App;
